"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceSize = void 0;
var _useWindowSize2 = require("./useWindowSize");
var useDeviceSize = function useDeviceSize() {
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    width = _useWindowSize.width;
  var isMobile = width < 768;
  var isTablet = width < 990 && width >= 768;
  var isDesktop = width >= 990;
  return {
    isMobile: isMobile,
    isDesktop: isDesktop,
    isTablet: isTablet
  };
};
exports.useDeviceSize = useDeviceSize;